import React from "react";
import { Field } from "redux-form";

import { TextWithLoader } from "components";

type FieldWithReadOnlyModeProps = {
	component: any;
	name: string;
	label: string;
	loading?: boolean;
	readOnlyProps: {
		isEditable: boolean;
		value: string | undefined | null;
	};
	[key: string]: any;
};

const FieldWithReadOnlyMode = ({
	component,
	name,
	label,
	loading,
	readOnlyProps: { isEditable, value },
	...props
}: FieldWithReadOnlyModeProps) => {
	return isEditable ? (
		<Field component={component} label={label} name={name} {...props} />
	) : (
		<TextWithLoader
			label={label}
			loading={loading || props?.blurLoading}
			value={value ?? ""}
		/>
	);
};

export default FieldWithReadOnlyMode;
